import { useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import { useNavigate } from "react-router-dom";

export default function AuthCallback() {
  const { instance } = useMsal();
  const navigate = useNavigate();

  useEffect(() => {
    instance
      .handleRedirectPromise()
      .then(() => navigate("/", { replace: true }))
      .catch((err) => {
        console.error("Auth callback failed", err);
        navigate("/login", { replace: true });
      });
  }, [instance, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-liaise-navy text-white">
      <p className="text-white/80">Completing sign-in...</p>
    </div>
  );
}
